module.exports = __webpack_public_path__ + "static/media/sort-shapes-down-alt.07f1897d.svg";